import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    AttachmentUploadUrlResponse,
    TAttachmentUploadUrlResponse,
} from "../../types/devices/ttr/getAttachmentUploadUrlsTypes"

type TAttachmentUploadUrlsMapper = {
    map: (response: unknown) => TAttachmentUploadUrlResponse
}

const attachmentUploadUrlMapper: TAttachmentUploadUrlsMapper = {
    map: (response: unknown): TAttachmentUploadUrlResponse =>
        tsIoValidate(
            AttachmentUploadUrlResponse,
            response,
            "getAttachmentUploadUrlsMapper"
        ),
}

export default attachmentUploadUrlMapper
